import React from 'react'
import { Container, Row } from 'react-bootstrap';
import "./Career.scss";
import career_banner from "../../Assets/img/career/banner-flip.jpg";
import { HeroBanner } from '../../Common/HeroBanner';
import purple2 from "../../Assets/img/career/purple2.jpg";
import main from "../../Assets/img/career/main.jpg";

const Career = () => {
  const applyLink = "https://docs.google.com/forms/d/e/1FAIpQLSdFvZxRbgJtYyN39Q4qB7JxeuGwLm2PQWrBFJlU8mpysy486w/viewform";

  return (
    <div>
      <Container fluid className='career-container'>
        <div className="py-3">
          <HeroBanner
            hero={career_banner}
            title={
              <>
                <div style={{color: '#30426D'}}>Work with Us!</div>
                <div className="strong pink">
                  <div>Join our team <br/></div>
                  <div>of RNs and Lactation Consultants</div>
                </div>
              </>
            }
          />
        </div>

        <Row no-gutter className='py-4' >
          <div className='col-lg-12 col-md-12 career-intro-section'>
            <div className='container'>
              <Row className='justify-content-center'>
                <div className='col-lg-8 col-md-8 col-sm-12'>
                  <div className='px-2 px-md-5 career_intro'>
                    <h2 className='text-center mb-4'>
                      <span className='strong'>Opportunities at NAPS</span>
                    </h2>
                    <p className='text-center p-0 mx-0 my-0'>
                      At NAPS, co-founders Emily and Jamie take great pride in the incredible team of Registered Nurses who provide exceptional care, education, and support to our families. We've been in business for over 14 years and were named one of the Best Places to Work in Boston, all thanks to the talented and compassionate nurses who make up our team.
                    </p>
                    <p className='text-center p-0 mx-0 my-0 mt-3'>
                      Whether you're just starting your career or bringing years of experience, there are many ways to be part of the NAPS family.
                    </p>
                  </div>
                </div>
              </Row>
            </div>
          </div>
        </Row>

        <Row className='py-4'>
          <div className='col-lg-12 col-md-12'>
            <Container fluid className='career-opportunities-main'>
              <Row className='justify-content-center'>
                <div className='col-lg-10 col-md-10'>
                  <Container>
                    <Row className='justify-content-center'>
                      <div className='col-lg-12 col-md-12 text-center mb-5'>
                        <h3 className="career-section-title">
                          <span className="strong">Career Opportunities</span>
                        </h3>
                      </div>
                    </Row>

                    <Row className='justify-content-center mb-5'>
                      <div className="col-lg-6 col-md-6 col-sm-12 text-center mb-4">
                        <img src={main} alt="" className="img-fluid"/>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 text-center mb-4">
                        <h3 className="career-section-title">
                          <span className="strong">RN Openings</span>
                        </h3>
                        <div className='career-opportunity-card'>
                          <h4>New Graduate RN Program</h4>
                        </div>
                        <div className='career-opportunity-card'>
                          <h4>Daytime and Overnight Nursing Care Roles</h4>
                        </div>
                        <div className='career-opportunity-card'>
                          <h4>Our Lactation Team</h4>
                        </div>
                      </div>
                    </Row>
                  </Container>
                </div>
              </Row>
            </Container>
          </div>
        </Row>

        <Row className='py-4'>
          <div className='col-lg-12 col-md-12'>
            <Container className='career-programs'>
              <Row className='justify-content-center'>
                <div className='col-lg-10 col-md-10'>
                  <Row className='justify-content-center mb-5'>
                    <div className='col-lg-12 col-md-12'>
                      <h3 className="career-section-title text-center mb-4">
                        <span className="strong">New Graduate RN Program</span>
                      </h3>
                      <p className='career-program-description'>
                        If you're a recent nursing graduate with a strong clinical background in maternal and newborn care, you don't have to "pay your dues" in the hospital before making an impact. At NAPS, we welcome new grads who are passionate about maternal-child health and want to start their careers in home-based care.
                      </p>
                      <p className='career-program-description'>
                        As part of our New Graduate Program, you'll receive:
                      </p>
                      <ul className='career-benefits-list'>
                        <li>Specialized training and mentorship during your first 6 months</li>
                        <li>Hands-on experience in home care for moms and babies</li>
                        <li>A supportive work environment led by experienced maternity nurses</li>
                      </ul>
                      <p className='career-program-description'>
                        <strong>Bonus:</strong> Many of our new grads go on to roles in hospital-based units like labor & delivery, postpartum, or NICU with confidence and experience.
                      </p>
                    </div>
                  </Row>

                  <Row className='justify-content-center mb-5'>
                    <div className='col-lg-12 col-md-12'>
                      <h3 className="career-section-title text-center mb-4">
                        <span className="strong">Experienced RN Opportunities</span>
                      </h3>
                      <p className='career-program-description'>
                        If you're an experienced nurse looking for more flexibility and purpose-driven work in maternal-child health, NAPS may be the perfect fit. We offer both full-time and per diem roles on our daytime and overnight care teams.
                      </p>
                      <p className='career-program-description'>
                        Why join NAPS as an experienced RN?
                      </p>
                      <ul className='career-benefits-list'>
                        <li>Flexible scheduling</li>
                        <li>Autonomy and support in the home care setting</li>
                        <li>A mission-driven team that values family-centered care</li>
                      </ul>
                    </div>
                  </Row>

                  <Row className='justify-content-center mb-5'>
                    <div className='col-lg-12 col-md-12'>
                      <h3 className="career-section-title text-center mb-4">
                        <span className="strong">Before You Apply</span>
                      </h3>
                      <p className='career-program-description'>
                        To be eligible for any RN role at NAPS, please ensure you:
                      </p>
                      <ul className='career-benefits-list'>
                        <li>Are willing and able to work overnight shifts</li>
                        <li>Have up-to-date vaccinations</li>
                        <li>Own a car for travel to client homes</li>
                      </ul>
                    </div>
                  </Row>

                  <Row className='justify-content-center mb-5'>
                    <div className='col-lg-12 col-md-12 text-center'>
                      <h4 className="mb-3">Ready to Apply?</h4>
                      <p className='mb-4'>All RN applicants (New Grads and Experienced RNs):</p>
                      <a href={applyLink} target="_blank" rel="noopener noreferrer" className="btn primary-blue-small-btn-40">
                        Apply Here
                      </a>
                    </div>
                  </Row>
                </div>
              </Row>
            </Container>
          </div>
        </Row>

        <Row className='py-4'>
          <div className='col-lg-12 col-md-12'>
            <Container fluid className='career-opportunities-main lactation-team-section'>
              <Row className='justify-content-center'>
                <div className='col-lg-10 col-md-10'>
                  <Container>
                    <Row className='justify-content-center'>
                      <div className='col-lg-12 col-md-12 text-center mb-5'>
                        <h3 className="career-section-title">
                          <span className="strong">Join Our Lactation Team</span>
                        </h3>
                        <p className='career-program-description'>
                          Our lactation team is made up of RNs and NPs who are also IBCLCs, delivering expert in-home and virtual support to families around the Boston area.
                        </p>
                      </div>
                    </Row>

                    <Row className='justify-content-center mb-5'>
                      <div className="col-lg-6 col-md-6 col-sm-12 text-center mb-4">
                        <img src={purple2} alt="" className="img-fluid"/>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 text-center mb-4">
                        <h4 className="mb-3" style={{color: '#30426D'}}>Requirements:</h4>
                        <ul className='career-benefits-list'>
                          <li>Active RN or NP license and IBCLC certification</li>
                          <li>Up-to-date vaccinations</li>
                          <li>Reliable transportation for home visits</li>
                        </ul>
                        <p className='career-program-description'>
                          If you're passionate about feeding support and education and want to work daytime consultations, we'd love to hear from you.
                        </p>
                      </div>
                    </Row>
                    <Row className='justify-content-center'>
                      <div className='col-lg-12 col-md-12 text-center'>
                        <h4 className="mb-3">Ready to Apply?</h4>
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSeToQkGrgQXu6lFmJKvhbCHX3kWXO8nTrA814rY1Ezfp3Tnzg/viewform" target="_blank" rel="noopener noreferrer" className="btn primary-blue-small-btn-40">
                          Apply Here
                        </a>
                      </div>
                    </Row>
                  </Container>
                </div>
              </Row>
            </Container>
          </div>
        </Row>

      </Container>
    </div>
  )
}

export default Career;
